import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Icompetition } from '../../model/Icompetition';

interface stepInterface {
  position: number;
  point: number;
};

@Component({
    selector: 'app-competion-modal',
    templateUrl: './competion-modal.component.html',
    styleUrls: ['./competion-modal.component.scss'],
    standalone: false
})
export class CompetionModalComponent implements OnInit {
  steps:stepInterface[]=[];
  public competition: Icompetition = {
    Id: 0,
    CompetitionName: '',
    EndOfVoting: '',
    EndoParticipation: '',
    participantCanAddImage: 1,
    numberOfVotes: 0,
    numberOfPositionedImages: 0,
    Logo: '',
    VisibleToVoterFrom: '',
    PubliclyVisible: 0,
    PubliclyVisibleFrom: '',
    NumberOfEntriesPerParticipant: 1,
    CompetingClub: '',
    VotiingClub: '',
    VotingPoints: '',
    subCompetitions: undefined,
    invitations: undefined,
    ImageAnalysis: 0
  };
  public validToSend = true;

  constructor(
    public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.competition.VotingPoints.length > 2) {
      this.steps = JSON.parse(this.competition.VotingPoints);
    } else {
    this.fillSteps();
    }
  }

  fillSteps() {
    this.steps = [];

    for (let i = this.competition.numberOfPositionedImages, j = 1; i > 0; i--, j++) {
      this.steps.push({position: j, point: i});
    }
  }

  passBack() {
    if (!this.competition.PubliclyVisible) {
      this.competition.PubliclyVisible = 0;
      this.competition.PubliclyVisibleFrom = '';
    } else {
      this.competition.PubliclyVisible = 1;
    }
    this.competition.VotingPoints = JSON.stringify(this.steps);
    this.activeModal.close(this.competition);
  }
}
